import React from 'react'
import styles from "./OptionsCard.module.css"

export default function OptionsCard(props) {
  return (
    <div className={`optionsCard ${styles.optionsCard}`}>
      {props.children}
    </div>
  )
}
